module.exports = __webpack_public_path__ + "img/punto-venta.d593f79b.svg";